import { createStyles } from 'antd-style';
import styled from '@emotion/styled';
import { Modal } from 'antd';

export const M = styled(Modal)`
  .ant-modal-close {
    top: 17px;
    &:hover {
      background-color: transparent !important;
    }
  }
  .ant-modal-header {
    margin-bottom: 24px;
  }
  .ant-modal-content {
    padding-bottom: 24px;
    padding-left: 0;

    padding-bottom: 0;
  }
  .ant-modal-footer {
    padding: 24px;
    padding-right: 0;
  }
  .ant-modal-body {
    padding: 0 24px;
  }
`;

export const useStyles = createStyles(({ token, css }) => {
  return {
    title: css`
      font-size: 20px;
      line-height: 16px;
      font-weight: 700;
      position: relative;
      padding-left: 24px;
      padding-bottom: 24px;
      border-bottom: 1px solid rgba(153, 153, 153, 0.20);
      margin-right: -24px;
    `,
    cancel: css`
      color: ${token.colorPrimary};
      border: 1px solid ${token.colorPrimary};
      background-color: #fff;
      border-radius: 4px;
      margin-right: 10px;
    `,
    confirm: css`
      border-radius: 4px;
    `,
    middle: css`
      padding: 0 40px;
      height: 40px;
    `,
    noCloseIcon: css`
      .ant-modal-close {
        display: none !important;
      }
    `
  };
});
